<template>
  <div>
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus"
          >添加</el-button
        >
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="{ row }">
            <el-button type="text" @click="edit(row)">编辑</el-button>
            <el-button type="text" @click="status(row)">{{
              row.IsDeactivate ? "停用" : "启用"
            }}</el-button>
            <el-button type="text" @click="review(row)">{{
              row.Status == 0 ? "审核" : "弃审"
            }}</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/business/sales/salemanage/promotion/list";
import editDialog from "@/components/business/sales/salemanage/promotion/editDialog";

export default {
  name: "promotion",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      type: 0,
    };
  },
  methods: {
    reload() {
      this.$refs.list.reload();
    },

    client() {
      this.$refs.clientDialog.openEdit();
    },
    product() {
      this.$refs.productDialog.openEdit();
    },
    create() {
      this.$refs.editDialog.openCreate();
    },
    // edit() {
    //   this.$refs.editDialog.openEdit();
    // },
    status(row) {
      const title = row.IsDeactivate
        ? "确认停用所选数据吗？"
        : "确认启用所选数据吗？";
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.updateStatus(row);
        })
        .catch(() => {});
    },
    review(row) {
      if (row.Status === 0) {
        this.$confirm("确认审核所选的数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$refs.list.review(row);
          })
          .catch(() => {});
      }
      if (row.Status === 1) {
        this.$confirm("确认弃审所选的数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$refs.list.back(row);
          })
          .catch(() => {});
      }
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.PromotionalPriceId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>
